export default "__VITE_ASSET__CN5I4m1b__"